<template>
  <span
    :class="containerClass"
    class="inline-flex items-center justify-center w-5 h-5 rounded-full"
    role="img"
    :aria-label="ariaLabel"
  >
    <svg
      v-if="kind === 'completed'"
      class="w-3 h-3"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
    </svg>
    <svg
      v-else-if="kind === 'failed'"
      class="w-3 h-3"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
    <svg
      v-else-if="kind === 'active'"
      class="w-3 h-3 animate-spin"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" />
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
    <span v-else class="block w-2 h-2 rounded-full bg-current" aria-hidden="true" />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { StepIconKind } from './presentation'

const props = defineProps<{ kind: StepIconKind }>()

const containerClass = computed(() => {
  switch (props.kind) {
    case 'completed':
      return 'bg-[#16a34a]/20 text-[#16a34a]'
    case 'failed':
      return 'bg-[#b42318]/20 text-[#b42318]'
    case 'active':
      return 'bg-[#1980e6]/20 text-[#1980e6]'
    case 'pending':
    default:
      return 'bg-gray-200 text-gray-400'
  }
})

// Status is otherwise only conveyed by color + glyph shape — give SR
// users an explicit step-state announcement (WCAG 1.1.1 + 1.4.1).
const ariaLabel = computed(() => {
  switch (props.kind) {
    case 'completed':
      return 'Step completed'
    case 'failed':
      return 'Step failed'
    case 'active':
      return 'Step in progress'
    case 'pending':
    default:
      return 'Step pending'
  }
})
</script>
